import React from "react";
import {useAppContext} from "@/contexts/app";
import {Alert} from "react-bootstrap";
import {inject, observer} from "mobx-react";

export function AlertsContext() {
    const {alerts, removeAlert} = useAppContext();

    const handleDismiss = (key: number) => {
        removeAlert(key);
    };

    return (
        <div className="alert-group">
            {Array.from(alerts).map(([id, message]) => (
                <Alert variant="success" dismissible={true} onClose={() => handleDismiss(id)} key={id}>
                    <p>{message}</p>
                </Alert>
            ))}
        </div>
    );
}

@inject("commonStore")
@observer
export class Alerts extends React.Component<any, any> {

    handleDismiss = (id: number) => {
        this.props.commonStore.removeAlert(id);
    };

    renderAlerts() {
        const alerts: any[] = [];
        for (const [key, value] of this.props.commonStore.statusAlerts) {
            alerts.push(
                <Alert variant="success" dismissible={true} onClose={() => this.handleDismiss(key)} key={key}>
                    <p>{value}</p>
                </Alert>
            );
        }
        return alerts;
    }

    render() {
        return (
            <>
                <div className="alert-group">
                    {this.renderAlerts()}
                </div>
            </>
        );
    }

}
